(function() {
  'use strict';

  /* Inject animation CSS */
  var style = document.createElement('style');
  style.textContent = [
    '[data-reveal]{opacity:0;transform:translateY(52px);transition:opacity .9s cubic-bezier(.16,1,.3,1),transform .9s cubic-bezier(.16,1,.3,1);will-change:opacity,transform}',
    '[data-reveal="left"]{transform:translateX(-52px)}',
    '[data-reveal="right"]{transform:translateX(52px)}',
    '[data-reveal="scale"]{transform:scale(.95) translateY(20px)}',
    '[data-reveal].is-revealed{opacity:1!important;transform:none!important}',
    '[data-delay="1"]{transition-delay:.1s}',
    '[data-delay="2"]{transition-delay:.2s}',
    '[data-delay="3"]{transition-delay:.3s}',
    '[data-delay="4"]{transition-delay:.4s}',
    '[data-delay="5"]{transition-delay:.5s}',
  ].join('');
  document.head.appendChild(style);

  function reveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-revealed)');
    var winH = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var rect = els[i].getBoundingClientRect();
      if (rect.top < winH - 60) {
        els[i].classList.add('is-revealed');
      }
    }
  }

  /* Throttle scroll */
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() { reveal(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });

  /* Initial check */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
